import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const AdminSectionInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Admin Section"
    sectionDisplayName="Admin"
    backRoute="/sections/admin-section"
  />
);

export default AdminSectionInwardConsignment;
